<template>
  <v-dialog width="620" v-model="dialog" persistent>
    <v-card>
      <v-card-title class="blue darken-4 white--text">
        <v-toolbar-title>CẬP NHẬP THÔNG TIN NHÂN VIÊN</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />

      <v-form v-bind="this.$attrs" ref="form">
        <v-card-text class="px-6 pt-6 pb-0">
          <v-text-field
            label="Họ tên"
            v-model="name"
            outlined
            :rules="[$rules.required]"
            class="required"
          ></v-text-field>
          <v-text-field
            label="Email"
            type="email"
            v-model="email"
            outlined
            :rules="[$rules.email, $rules.required]"
            class="requried"
          ></v-text-field>
          <v-select
            label="Vai trò"
            :items="roles"
            item-text="type"
            item-value="id"
            v-model="role"
            class="required"
            outlined
            required
            :rules="[$rules.role]"
          ></v-select>
          <v-select
            label="Trạng thái"
            :items="statusOptions"
            item-text="label"
            item-value="value"
            v-model="blocked"
            class="required"
            outlined
            required
            :rules="[$rules.status]"
          ></v-select>

          <v-text-field
            label="Mật khẩu"
            v-model="password"
            outlined
            required
            class="required"
            :rules="[$rules.nospace, $rules.minLength(6)]"
          ></v-text-field>
          <v-text-field
            label="Nhập lại mật khẩu"
            v-model="password2"
            required
            class="required"
            :rules="[$rules.nospace, $rules.minLength(6), $rules.passInputAgain(password2, password)]"
            outlined
          ></v-text-field>
        </v-card-text>
        <v-card-actions class="pt-0 px-6 pb-6">
          <v-btn color="blue darken-4" outlined @click="close">Hủy </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-4" dark @click="submit">Xác nhận</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
export default {
  props: {
    state: Boolean,
    profile: Object,
    roles: Array
  },
  watch: {
    state(state) {
      this.dialog = state
      if (!state) this.loading = false
    },
    profile: {
      immediate: true,
      handler(newProfile) {
        if (newProfile) {
          this.setFormValues(newProfile)
        }
      }
    }
  },
  computed: {
    ...mapGetters('auth', ['user'])
  },
  data() {
    return {
      dialog: false,
      loading: false,
      name: '',
      username: '',
      email: '',
      role: '',
      blocked: '',
      password: '',
      password2: '',
      statusOptions: [
        {label: 'Đang hoạt động', value: 'false'},
        {label: 'Đã bị khóa', value: 'true'}
      ]
    }
  },
  methods: {
    ...mapActions('user', ['updateUser']),

    close() {
      this.$emit('closeDialog')
    },

    async submit() {
      if (this.$refs.form.validate()) {
        this.$loading.active = true
        let data = {name: this.name, username: this.username, email: this.email, role: this.role, blocked: this.blocked}
        const updateSale = await this.updateUser({id: this.profile.id, ...data})
        if (updateSale) {
          this.$emit('refresh')
          this.close()
        }
      }
    },
    setFormValues(profile) {
      this.name = profile.name || ''
      this.username = profile.username || ''
      this.email = profile.email || ''
      this.role = profile.role ? profile.role.id : ''
      this.blocked = typeof profile.blocked === 'boolean' ? profile.blocked.toString() : ''
    }
  }
}
</script>

<style>
.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 2px !important;
}
</style>
